module.exports = __webpack_public_path__ + "images/sam/loading.gif";